export default __webpack_public_path__ + "static/cinnamon_large_square-c210b1aa8874260a34cf8cf0971ead55.jpg";